module.exports = __webpack_public_path__ + "static/Q1Answer1_Alonetime_AntonDarius_1-26066f9a928582bd2fc6b1b1efdb929c.jpg";